var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAmReloadSim(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 324,
    height: 72,
    viewBox: "0 0 324 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.0078 65.9941C59.3578 65.9941 57.9458 65.4071 56.7718 64.2331C55.5978 63.0591 55.0098 61.6461 55.0078 59.9941V23.9941L73.0078 5.99414H97.0078C98.6578 5.99414 100.071 6.58214 101.247 7.75814C102.423 8.93414 103.01 10.3461 103.008 11.9941V59.9941C103.008 61.6441 102.421 63.0571 101.247 64.2331C100.073 65.4091 98.6598 65.9961 97.0078 65.9941H61.0078ZM61.0078 59.9941H97.0078V11.9941H75.5578L61.0078 26.5441V59.9941Z",
    fill: "#264C86"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M138 36V36.03M150.198 36V36.03M162.396 36V36.03M174.595 36V36.03M186.793 36V36.03",
    stroke: "#244C84",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M222.05 54C227.45 60.75 235.55 65.25 245 65.25C261.2 65.25 274.25 52.2 274.25 36C274.25 19.8 261.2 6.75 245 6.75C235.1 6.75 226.55 11.7 221.15 18.9M220.25 4.5V18C220.25 19.35 221.15 20.25 222.5 20.25H236",
    stroke: "#264C86",
    strokeWidth: 6,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmReloadSim);
export default __webpack_public_path__ + "static/media/am-reload-sim.1793aa7f87b7f985bf246a629f9a0a4c.svg";
export { ForwardRef as ReactComponent };